/**
 * Clear app wide cookies such as session, csrftoken, django_session,
 * including `CloudFront` cookies
 * */
export function clearAppCookies() {
  // Clear CloudFront cookies AND Django session cookies
  const cookies = [
    "CloudFront-Policy",
    "CloudFront-Signature",
    "CloudFront-Key-Pair-Id",
    "sessionid", // Django session cookie
    "csrftoken", // Django CSRF token
    "django_session" // Alternative Django session name
  ];
  const expiry = "expires=Thu, 01 Jan 1970 00:00:00 UTC";

  console.log("🍪 Clearing cookies:", cookies);

  // Clear for current domain
  cookies.forEach((cookie) => {
    document.cookie = `${cookie}=; ${expiry}; path=/;`;
    console.log(`🍪 Cleared cookie: ${cookie} for current domain`);
  });

  // Clear for parent domain (e.g., .culturemap.app)
  const hostname = window.location.hostname;
  if (hostname.includes(".")) {
    const domain = hostname.split(".").slice(-2).join(".");
    cookies.forEach((cookie) => {
      document.cookie = `${cookie}=; ${expiry}; path=/; domain=.${domain};`;
      console.log(`🍪 Cleared cookie: ${cookie} for domain: .${domain}`);
    });
  }
}
